import type { z } from "zod";
import type { FollowResponse_Schema, FollowUser_Schema, FollowUserList_Schema } from "@/services/user/follow/followSchema";

export type FollowState = z.infer<typeof FollowResponse_Schema>;

export type FollowUser = z.infer<typeof FollowUser_Schema>;
export type FollowUserList = z.infer<typeof FollowUserList_Schema>;

/** Which side of the follow relation a listing shows. Serialized into the endpoint path. */
export enum FollowDirection {
  /** Users following the given collector. */
  Followers = "followers",
  /** Users the given collector follows. */
  Following = "following",
}

export type FollowUserListRequest = {
  page: number;
  perPage: number;
  /** Case-insensitive substring of the nickname; empty or undefined lists everyone. */
  nickname?: string;
};
